import styled from "@emotion/styled";

export const SectionBannerStyled = styled.div`  
  margin-right: 10px;
  border: 2px solid black;
  align-items: center;
  color:  #000;
  font-weight: bold;  
  padding: 8px;
  background-color: #ffd9d9;  
  border-radius: 6px;  
`;

export const PilotBannerStyled = styled(SectionBannerStyled)`
  background-color: #ffd700; /* Gold/Yellow color */
  border-color: #b8860b; /* DarkGoldenRod - darker border */
`;
